module.exports = __webpack_public_path__ + "img/fa-truck.04e3b5a7.svg";